<script>
    // Import the base chart
    import {Bar} from 'vue-chartjs'

    // Extend it
    export default {
        extends: Bar,
        props: {
            chartdata: {
                type: Object,
                default: null
            },
            options: {
                type: Object,
                default: null
            }
        },
        mounted() {
            // Overwriting base render method with actual data and options
            this.renderChart(this.chartdata, this.options)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Outils/BarChartjs.vue